import AddEditDialog from "../UI/AddEditDialog";
import fields from "../../Utils/Fields/transactionRulesFields";
import endpoint from "../../Utils/endpoint";

const AddEditTransactionRulesDialog = ({
  openDialog,
  afterClose = () => {},
  dialogMode,
  patchData,
}) => {
  return (
    <AddEditDialog
      openDialog={openDialog}
      title="Transactieregels"
      fields={fields}
      afterClose={afterClose}
      width="900px"
      endpoint={endpoint.transactionRules}
      dialogMode={dialogMode}
      patchData={patchData}
    />
  );
};

export default AddEditTransactionRulesDialog;
